<template>
    <div class="table-responsive">
        <table :class="tableClass">
            <caption v-if="caption" class="text-center">{{ caption }}</caption>
            <thead v-if="headers.length > 0">
                <tr>
                    <template v-for="(header, index) in visibleHeaders">
                        <th :colspan="getColspan(header)" :key="index" :class="{
                            'nowrap': !shouldWrap(header)
                        }">
                            {{ getLabel(header) }}
                        </th>
                    </template>
                </tr>
            </thead>
            <tbody>
                <slot></slot>
                <tr v-show="isLoading">
                    <td :colspan="headers.length">
                        <x-loading iconClass="fa-2x" />
                    </td>
                </tr>
                <tr v-show="!$slots.default && !isLoading && showEmpty">
                    <td :colspan="headers.length">
                        <slot name="empty-text">Data kosong</slot>
                    </td>
                </tr>
            </tbody>
            <tfoot v-if="$scopedSlots.footer">
                <slot name="footer" :colspan="headers.length"></slot>
            </tfoot>
        </table>
    </div>
</template>

<script>
import { isString } from '../helpers'
import XLoading from './XLoading.vue'
import { get } from 'lodash'
export default {
    components: { 
        XLoading,
    },
    computed: {
        visibleHeaders() {
            return this.headers.filter(header => {
                return (isString(header) || get(header, 'visible', true))
            })
        }
    },
    props: {
        caption: {
            type: String,
            required: false,
            default: null,
        },
        headers: {
            type: Array,
            required: false,
            default: () => [],
        },
        isLoading: {
            type: Boolean,
            required: false,
            default: false,
        },
        showEmpty: {
            type: Boolean,
            required: false,
            default: true,
        },
        tableClass: {
            type: String,
            required: false,
            default: 'table table-striped table-bordered',
        },
    },
    methods: {
        getColspan(header) {
            if (isString(header)) {
                return 1
            }
            return header.colspan || 1
        },
        getLabel(header) {
            if (isString(header)) {
                return header
            }
            return header.label || ''
        },
        shouldWrap(header) {
            if (isString(header)) {
                return false
            }
            return header.wrap || false
        },
    }
}
</script>
